import React, { useState } from "react";
import CustomModal from "../common/Modal";

interface ImpressumProps {
    headerText: string;
}

export const ImpressumModal: React.FC<ImpressumProps> = ({ headerText }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const modal_id = "release-notes-modal";

    const handleReleaseNotesModelClose = () => {
        const modal = document.getElementById(modal_id) as HTMLDialogElement;
        if (modal) modal.close();
    };

    return (
        <div className="">
            <button
                className="btn btn-link !text-navbar-item !font-navbar-item !text-darkpink !no-underline hover:!underline pr-4"
                onClick={() => {
                    setIsModalOpen(true);
                }}
            >
                Release Notes
            </button>
            <CustomModal
                headerText={headerText}
                onCancel={handleReleaseNotesModelClose}
                modal_id={modal_id}
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
            >
                <div>
                    <p className="font-chat-text text-chat-text py-4">
                        Hier findest du eine Übersicht über die neuesten Updates und Verbesserungen für
                        NextGeneration:AI.
                    </p>
                    <div className="pb-4">
                        <h3 className="label font-modal-item text-modal-item">
                            Version 1.2.0 - Export-Funktion für Szenarien
                        </h3>
                        <ul className="font-chat-text text-chat-text">
                            <li>- JSON-Export für Szenarien</li>
                            <li>- JSON-Import für Szenarien bei der Erstellung von neuen Szenarien</li>
                            <li>- Einige technische Updates im Hintergrund</li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="label font-modal-item text-modal-item">
                            Version 1.1.0 - GPT-4o Mini Integration
                        </h3>
                        <ul className="font-chat-text text-chat-text">
                            <li>- GPT-3.5 Turbo durch GPT-4o Mini ersetzt</li>
                        </ul>
                    </div>
                </div>
            </CustomModal>
        </div>
    );
};

export default ImpressumModal;
